module.exports = __webpack_public_path__ + "static/media/arrow-down-black.dffc5e04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/arrow-down-black.svg
// module id = 137
// module chunks = 0